export default __webpack_public_path__ + "static/media/Mark-2-Suit-09.7e938bf8.jpg";